<div class="app-container">
  <div class="header-section">
    <app-header></app-header>
    <!-- <app-landing-page-goals
    (apiEvent)="apiEventHandle($event)"
  ></app-landing-page-goals> -->
  </div>
  <!-- <app-landing-page
  [selectedApi]="apiStatus"
  [showOpen]="showOpenApi"
  [showFix]="showFixApi"
  [showBackOffice]="showBackOfficeApi"
></app-landing-page> -->
  <div class="main-content">
    <app-landing-product-page></app-landing-product-page>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>